import React from 'react';
import { approaches } from '../../../data/site';
import SectionIntro from '../../primitives/SectionIntro';
import Reveal from '../../primitives/Reveal';
import TraceRule from '../../primitives/TraceRule';

// How we work: three commitments set as an editorial row of numbered columns
const Approach = ({ index = '04' }) => (
  <section className="section">
    <div className="container-site">
      <SectionIntro index={index} label="How we work" title="Our journey *together*" />
      <div className="mt-[clamp(3rem,6vw,5rem)] grid gap-12 md:grid-cols-3 md:gap-8">
        {approaches.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.1}>
            <TraceRule jog={0.12 + i * 0.3} delay={i * 0.12} />
            <span className="label mt-8 block text-brand-ink">{String(i + 1).padStart(2, '0')}</span>
            <h3 className="title-lg mt-4 max-w-[14ch]">{item.title}</h3>
            <p className="mt-5 leading-relaxed text-muted-foreground">{item.description}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Approach;
